import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import CatalogProductCard from '../../Components/CatalogProductCardOld';
import { __ } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import API2 from '../../../../API2';

const ListOfProducts = styled.div`
  padding: ${rem(10)};
  padding-right: ${rem(20)};
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem(315)}, auto));
  grid-gap: 0rem;
`;

class Catalog extends BaseList {
  constructor(props) {
    super(props);
    this.pageSizes = [60, 90, 120];
    this.defaultLimit = 60;
    this.state = {
      ...this.state,
      maxFilterWidth: 140,
      title: __('Produktový katalóg - zoznam'),
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      limit: 60,
      isProduct: true,
      defaultFilter: [],
    };

    actions.setActiveMenuItem('71');
  }

  componentDidUpdate(prevProps) {
    console.log('prevProps----', prevProps);
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
      searchText,
      scrollPosition,
    } = this.loadActualData();

    const { buttonsSwitch } = this.state;

    this.setState(
      {
        buttonsSwitch,
        searchText,
        defaultSearchText: searchText,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter:
          checkedFilter && checkedFilter !== 'undefined'
            ? JSON.parse(checkedFilter)
            : [...this.state.defaultFilter],
      },
      async () => {
        this.fetchFilter(!checkedFilter || checkedFilter.length === 0);
        await this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        window.scrollTo({
          top: scrollPosition ? Number(scrollPosition) : 0,
        });
      },
    );

    this.saveActualData(1, 0, null, [], null, '');
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (this.props.location.pathname === '/buy/sales') {
        params.categoryName = 'vypredaj';
      }

      const newData = await API2.getLiteB2BCatalogProductsAction(
        Object.assign(params, { limit }),
      );

      this.setState({
        items: newData.products,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  openProduct(id) {
    this.props.history.push(`/catalog/list/${id}`);
  }

  renderItemsList() {
    const { items } = this.state;

    return (
      <ListOfProducts>
        {items.map(p => {
          return (
            <CatalogProductCard
              appLang={this.props.appLang}
              settings={this.props.settings}
              onProductClick={() => this.openProduct(p._id)}
              productLink={`/catalog/list/${p._id}`}
              firm={this.props.user.firm}
              data={p}
              location={this.props.location}
              history={this.props.history}
              customerId={this.props.user._id}
            />
          );
        })}
      </ListOfProducts>
    );
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Catalog);



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Catalog/List/index.jsx